import React from "react";

const BlogCategoryFilter = ({ categories, value, onChange }) => (
  <div className="flex flex-wrap gap-2" data-testid="blog-category-filter">
    <button onClick={() => onChange("all")} className={`border px-4 py-2 font-mono text-xs uppercase tracking-[0.2em] ${value === "all" ? "bg-white text-black border-white" : "border-white/20 hover:border-white"}`}>
      All
    </button>
    {categories.map((category) => (
      <button
        key={category}
        onClick={() => onChange(category)}
        className={`border px-4 py-2 font-mono text-xs uppercase tracking-[0.2em] ${value === category ? "bg-cynos-red text-white border-cynos-red" : "border-white/20 hover:border-white"}`}
      >
        {category}
      </button>
    ))}
  </div>
);

export default BlogCategoryFilter;
